import React from 'react'
import APIMerchandisingFlight from './Flight/APIMerchandisingFlight';
import APIMerchandisingHotel from './Hotel/APIMerchandisingHotel';
import APIMerchandisingActivity from './Activity/APIMerchandisingActivity';

const APIMerchandising = ({ useradd, useredit, userexport, toggleSequencing }) => {
    return (
        <>
            <div className="container-fluid my-2">
                <div className='container mt-3 mb-2 tab_section px-0'>
                    <ul className="nav nav-pills nav-justified mb-3 pt-3 col-lg-4 col-12 mx-auto" id="pills-tab" role="tablist">
                        <li className="nav-item mt-1 mx-1" role="presentation">
                            <button className="nav-link active"
                                id="pills-FlightMerchandising-tab"
                                data-bs-toggle="pill"
                                onClick={() => toggleSequencing('.API-merchandising-for-hotel')}
                                data-bs-target="#pills-FlightMerchandising"
                                type="button" role="tab"
                                aria-controls="pills-FlightMerchandising"
                                aria-selected="true">
                                <strong>Flights</strong>
                            </button>
                        </li>
                        <li className="nav-item mt-1 mx-1" role="presentation" >
                            <button className="nav-link API-merchandising-for-hotel"
                                id="pills-HotelMerchandising-tab"
                                data-bs-toggle="pill"
                                onClick={() => toggleSequencing('.API-merchandising-for-hotel')}
                                data-bs-target="#pills-HotelMerchandising" type="button" role="tab" aria-controls="pills-HotelMerchandising"
                                aria-selected="false">
                                <strong >Hotels</strong>
                            </button>
                        </li>
                        {/* <li className="nav-item mt-1 mx-1" role="presentation" >
                            <button className="nav-link API-merchandising-for-hotel"
                                id="pills-ActivityMerchandising-tab"
                                data-bs-toggle="pill"
                                onClick={() => toggleSequencing('.API-merchandising-for-hotel')}
                                data-bs-target="#pills-ActivityMerchandising" type="button" role="tab" aria-controls="pills-ActivityMerchandising"
                                aria-selected="false">
                                <strong >Activities</strong>
                            </button>
                        </li> */}
                    </ul>
                </div>
                <div className="tab-content" id="pills-tabContent">
                    <div className="tab-pane fade show active" id="pills-FlightMerchandising" role="tabpanel"
                        aria-labelledby="pills-FlightMerchandising-tab">
                        <APIMerchandisingFlight useradd={useradd} useredit={useredit} userexport={userexport} />
                    </div>
                    <div className="tab-pane fade show" id="pills-HotelMerchandising" role="tabpanel"
                        aria-labelledby="pills-HotelMerchandising-tab">
                        <APIMerchandisingHotel useradd={useradd} useredit={useredit} userexport={userexport} />
                    </div>
                    {/* <div className="tab-pane fade show" id="pills-ActivityMerchandising" role="tabpanel"
                        aria-labelledby="pills-ActivityMerchandising-tab">
                        <APIMerchandisingActivity useradd={useradd} useredit={useredit} userexport={userexport} />
                    </div> */}
                </div>
            </div>
        </>
    )
}

export default APIMerchandising